var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9576 13.0171L16.8041 16.8637C17.0653 17.1216 17.0653 17.5461 16.8041 17.8041C16.5429 18.0653 16.1216 18.0653 15.8604 17.8041L12.0139 13.9608C10.8514 14.9143 9.36571 15.4857 7.74286 15.4857C4.01714 15.4857 1 12.4653 1 8.74286C1 5.02041 4.01714 2 7.74286 2C11.4653 2 14.4857 5.02041 14.4857 8.74286C14.4857 10.3657 13.911 11.8547 12.9576 13.0171ZM2.33878 8.74286C2.33878 11.7208 4.76163 14.1437 7.74286 14.1437C10.7208 14.1437 13.1469 11.7208 13.1469 8.74286C13.1469 5.7649 10.7208 3.33878 7.74286 3.33878C4.76163 3.33878 2.33878 5.7649 2.33878 8.74286Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSearch);
export default __webpack_public_path__ + "static/media/ic_search.ee3c48d2522a81afd3af6636677a36a0.svg";
export { ForwardRef as ReactComponent };